const init = () => {
    document.addEventListener('DOMContentLoaded', function() {
        var $reviews = $('.c-reviews');
        if ($reviews.length < 1) return;
        var $readMore = $reviews.find('.c-reviews__btn');

        $readMore.on('click', function() {
            $reviews.toggleClass('is-expanded');
            if ($reviews.hasClass('is-expanded')) {
                $readMore.text('Show less');
            } else {
                $readMore.text('Show all');
            }
        });
    });
}

export default init;
